export enum SCHEDULE_DATE_TYPE {
  StartDate = "startDate",
  EndDate = "endDate"
}

export enum QUICK_DOWNLOAD_STATUS {
  Deactivated = "deactivated",
  Disabled = "disabled",
  Initiated = "initiated",
  New = "new"
}

export enum DRIVER_SCOPE {
  Both = "Both",
  None = "None",
  Slot1 = "Slot1",
  Slot2 = "Slot2"
}
